export { default } from "./ProductDetail";

